import React from 'react';
import Logo from '../Base';
import SuccessIconComponent from './style';

const Index = (props) => {
  return <Logo {...props} SuccessIconComponent={SuccessIconComponent} />;
};

export default Index;
